/**
 * Google Tags Service
 * Service để quản lý Google Tag Manager và Google Analytics
 */

/**
 * Thêm Google Tag Manager script vào head và body
 * @param {string} gtag_key - Google Tag Manager ID (ví dụ: "GTM-K8ZV46JK" hoặc "G-CEC80G3PJN")
 * @param {string} type - Loại tag: 'gtm' (Google Tag Manager) hoặc 'ga' (Google Analytics)
 */
export function addGoogleTags(gtag_key, type = 'gtm') {
    if (!gtag_key) {
        console.warn('Google Tags: gtag_key is required');
        return;
    }

    if (type === 'gtm') {
        addGTMTag(gtag_key);
    } else if (type === 'ga') {
        addGATag(gtag_key);
    } else {
        console.warn('Google Tags: Invalid type. Use "gtm" or "ga"');
    }
}

/**
 * Thêm Google Tag Manager script
 * @param {string} gtag_key - GTM Container ID
 */
function addGTMTag(gtag_key) {
    // Kiểm tra xem script đã được thêm chưa
    if (document.getElementById('gtag-js-GTM')) {
        return;
    }

    // Load GTM script
    var gtmScript = document.createElement('script');
    gtmScript.id = 'gtag-js-GTM';
    gtmScript.async = true;
    gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtag_key}');
    `;
    document.head.appendChild(gtmScript);

    // Add noscript iframe to body
    var noscript = document.createElement('noscript');
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=' + gtag_key;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.appendChild(noscript);
}

/**
 * Thêm Google Analytics (gtag.js) script
 * @param {string} gtag_key - GA Measurement ID (ví dụ: "G-CEC80G3PJN")
 */
function addGATag(gtag_key) {
    // Kiểm tra xem script đã được thêm chưa
    if (document.getElementById('gtag-js-GA4')) {
        return;
    }

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', gtag_key);

    // Load gtag.js script
    var gaScript = document.createElement('script');
    gaScript.id = 'gtag-js-GA4';
    gaScript.async = true;
    gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + gtag_key;
    document.head.appendChild(gaScript);

    // Add inline script for gtag initialization
    var gaScriptInline = document.createElement('script');
    gaScriptInline.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${gtag_key}');
    `;
    document.head.appendChild(gaScriptInline);
}

/**
 * Gửi event đến Google Tag Manager / Google Analytics
 * @param {string} eventName - Tên event (ví dụ: 'clickHotline', 'clickMessenger')
 * @param {string|object} value - Giá trị hoặc object chứa thông tin event
 * @param {object} additionalParams - Các tham số bổ sung cho event
 */
export function trackEvent(eventName, value = null, additionalParams = {}) {
    if (!window.dataLayer) {
        window.dataLayer = [];
    }

    const eventData = {
        event: eventName,
        ...additionalParams
    };

    if (value !== null) {
        if (typeof value === 'object') {
            Object.assign(eventData, value);
        } else {
            eventData.value = value;
        }
    }
    console.log(eventData);
    console.log(window.dataLayer);
    window.dataLayer.push(eventData);
    console.log(window.dataLayer);
}

/**
 * Gửi page view event
 * @param {string} pagePath - Đường dẫn trang
 * @param {string} pageTitle - Tiêu đề trang
 */
export function trackPageView(pagePath, pageTitle = '') {
    trackEvent('page_view', {
        page_path: pagePath,
        page_title: pageTitle
    });
}

/**
 * Gửi custom event với nhiều tham số
 * @param {object} eventData - Object chứa thông tin event
 */
export function trackCustomEvent(eventData) {
    if (!window.dataLayer) {
        window.dataLayer = [];
    }

    if (!eventData.event) {
        console.warn('Google Tags: event name is required');
        return;
    }

    window.dataLayer.push(eventData);
}

// Export default object với tất cả các functions
export default {
    trackEvent,
    trackPageView,
    trackCustomEvent
};
